import React from 'react';
import FormLabel from '@mui/material/FormLabel';

function CustomFormLabel(props) {
    return(
        <FormLabel style={{marginBottom: '10px'}}>{props.content}</FormLabel>
    );
}

export default CustomFormLabel